<template>
  <div class="flex flex-row align-middle">
    <span class="text-2xl font-semibold"> {{ integerPart }},</span>
    <span class="pt-1 text-xs font-semibold">
      {{ cents }}
    </span>
    <span class="ml-1 text-2xl font-semibold"> € </span>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  number: number;
}>();

const { n } = useI18n();

const integerPart = computed(() =>
  n(Math.floor(props.number), {
    maximumFractionDigits: 0,
  }),
);

const cents = computed(() => {
  const v = Math.floor(props.number * 100) % 100;
  return v < 10 ? '0' + v : v;
});
</script>
